import React from "react";
import styles from "fantastic/components/hoc/styles";

const Cell = ({ style, className, children }) => {
  return (
    <td style={style} className={className}>
      {children}
    </td>
  );
};

export default styles("width:%", "background")(Cell);
